export function dataInRequest(params = {}) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagemSistemaEquipamentoPosto/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagemSistemaEquipamentoPosto/RECORD_FILTERING',
    payload: { params },
  };
}
